/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

export const Apple = ({ size = FontSizes[1], style, variant = 'primary' }) => (
    <IconWithVariant
        data-testid="appleIcon"
        variant={variant}
        src="Apple"
        size={size}
        wrapperProps={{ ...style }}
    />
);
